import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "src/utils/imageUrl";

const CardLayout = ({ data, closeMenu }) => {
  const [animatePhase1, setAnimatePhase1] = useState(false); // Top to bottom

  useEffect(() => {
    // Phase 1: Top to bottom animation starts after 350ms
    const timer1 = setTimeout(() => setAnimatePhase1(true), 350);

    
    return () => {
      clearTimeout(timer1);
    };
  }, []);

  return (
    <div className="grid md:grid-cols-3 container mx-auto justify-start py-8 gap-6 md:gap-8 flex-wrap">
      {data &&
        data.map((item, index) => (
          <div
            key={index}
            className={`relative isolate overflow-hidden rounded-2xl group transform transition-all duration-500 ease-out
              ${animatePhase1 ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-10'}
            `}
            style={{ 
              aspectRatio: '2/1', 
              transitionDelay: `${index * 100}ms` 
            }}
          >
            <div className="w-full h-full md:pt-4">
              <img
                src={getImageUrl(item.img)}
                alt={item.heading}
                className="w-full h-full object-fill transform transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            {/* Darker overlay with stronger gradient for better text visibility */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>

            <div className="absolute inset-0 flex items-end flex-wrap">
              <div className="p-4 md:p-6 w-full">
                <h4 className="z-10 text-white overflow-hidden text-[16px] md:text-[32px] leading-tight capitalize font-outfitMedium w-[115px] md:w-[180px] mb-0 md:mb-2 drop-shadow-lg line-clamp-2">
                  {item.heading}
                </h4>
                <Link
                  to={`${item.link}`}
                  onClick={closeMenu}
                  className="btn-primary inline-block px-3 py-1 md:px-5 md:py-2 transition-all duration-300 rounded-full mt-3 text-[12px] md:text-[14px] font-outfitSemiBold uppercase"
                  style={{ backgroundColor: 'var(--btn-primary-bg)', color: 'var(--btn-primary-text)' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--btn-primary-hover-bg)';
                    e.currentTarget.style.color = 'var(--btn-primary-hover-text)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--btn-primary-bg)';
                    e.currentTarget.style.color = 'var(--btn-primary-text)';
                  }}
                >
                  Shop Now
                </Link>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default CardLayout;
